// Importing React and related hooks
import React, { useState, useEffect } from "react";

// Importing custom WPMSelector styles
import "../../styles/practicePage/WPMSelector.css";

function WPMSelector({ reset, onWPMChange }) {
  // State hook to manage the WPM value
  const [wpm, setWpm] = useState(10);

  // Function to handle slider value changes
  const handleSliderChange = (e) => {
    setWpm(e.target.value); // Update the local WPM state
    onWPMChange(e.target.value); // Pass updated value to parent component
  };

  // Calculate the progress percentage based on the WPM value
  const progressPercentage = ((wpm - 4) / (30 - 4)) * 100;

  // Effect hook to reset the WPM value when reset prop changes
  useEffect(() => {
    if (reset) {
      setWpm(10); // Reset WPM value to 10
      onWPMChange(10); // Reset parent WPM value to 10
    }
  }, [reset, onWPMChange]); // Re-run when reset or onWPMChange changes

  return (
    <div className="wpmSelector mt-4">
      {/* Label for the slider */}
      <label htmlFor="wpm">Speed (WPM): </label>

      {/* Range slider for selecting WPM */}
      <input
        id="wpm"
        type="range"
        min="4" // Minimum WPM
        max="30" // Maximum WPM
        value={wpm} // Set current WPM value
        onChange={handleSliderChange} // Trigger onChange when slider is moved
        style={{
          "--progress-percentage": `${progressPercentage}%`, // Dynamically set progress bar
        }}
      />

      {/* Display current WPM value */}
      <div className="rangeValue">{wpm} WPM</div>
    </div>
  );
}

export default WPMSelector;
